<div class="grid mt-0 presentation-large-container cards-gutter justify-content-start mx-auto">
  @for (card of cards(); track $index) {
    @switch (card.type) {
      @case (ContentComponentType.CARD_GENERAL) {
        <div class="ppg-container-card-item">
          <ppg-general-card
            class="flex align-items-center justify-content-center h-full"
            [generalCard]="card"
            [isResponsive]="true" />
        </div>
      }
      @case (ContentComponentType.CARD_ASSET_URL_CONTENT) {
        <div class="ppg-container-card-item">
          <ppg-asset-url-card
            class="flex align-items-center justify-content-center h-full"
            [generalAssetUrlCard]="card"
            [isResponsive]="true" />
        </div>
      }
      @case (ContentComponentType.CARD_ASSET_YOUTUBE_VIDEO) {
        <div class="ppg-container-card-item">
          <ppg-asset-youtube-video-card
            class="flex align-items-center justify-content-center h-full"
            [generalAssetYoutubeVideoCard]="card"
            [isResponsive]="true" />
        </div>
      }
      @case (ContentComponentType.CARD_PAGE) {
        <div class="ppg-container-card-item">
          <ppg-page-card
            class="flex align-items-center justify-content-center h-full"
            [generalPageCard]="card"
            [isResponsive]="true" />
        </div>
      }
      @case (ContentComponentType.CARD_ASSET_DOCUMENT) {
        <div class="ppg-container-card-item">
          <ppg-asset-document-card
            class="flex align-items-center justify-content-center h-full"
            [generalAssetDocumentCard]="card"
            [isResponsive]="true" />
        </div>
      }
    }
  }
</div>
